module.exports = __webpack_public_path__ + "static/media/clock.77ad56a2.svg";